import React, { useMemo, useState } from "react";
import { format, parse } from "date-fns";
import Table from "../../../components/ui/table/Table";
import { downloadLoader } from "../../../assetData/loaders";

const IndustryScripConfig = ({ tableData, buttonConfig, loading }) => {
  const [loadingRows, setLoadingRows] = useState({});

  const handleReload = async (date, fileType, rowId) => {
    setLoadingRows((prev) => ({ ...prev, [rowId]: true }));
    const res = await buttonConfig?.handleReload(date, fileType);
    if (res) {
      setLoadingRows((prev) => {
        const { [rowId]: _, ...rest } = prev;
        return rest;
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "date",
        header: "DATE",
        Cell: ({ row }) => format(new Date(row.original.date), "dd MMM yyyy"),
        size: 125,
        sortingFn: "datetime",
      },
      {
        accessorKey: "day",
        header: "WEEKDAY",
        size: 130,
      },
      {
        accessorKey: "file_type",
        header: "File Recd",
        size: 125,
        mantineTableBodyCellProps: { sx: { textTransform: "uppercase" } },
      },
      {
        accessorKey: "service_name",
        header: "Service Name",
        size: 160,
      },
      {
        accessorKey: "ip_cnt",
        header: " Records Received",
        size: 160,
        mantineTableHeadCellProps: { align: "right" },
        mantineTableBodyCellProps: { align: "right" },
      },

      {
        accessorKey: "op_cnt",
        header: " Records Inserted",
        size: 160,
        mantineTableHeadCellProps: { align: "right" },
        mantineTableBodyCellProps: { align: "right" },
      },
      {
        accessorKey: "operation_status",
        header: "STATUS",
        size: 130,
      },
      {
        id: "reload",
        header: "ACTIONS",
        size: 105,

        Cell: ({ row }) => {
          const isLoading = !!loadingRows[row.id];
          const isSuccess = row.original.operation_status === "Success";
          const disabled = isLoading || isSuccess;
          console.log(row.original);
          return (
            <button
              className={`flex h-[25px] w-[70px] items-center justify-center rounded bg-pri-clr-orange px-2 py-1 text-white transition hover:brightness-95 ${disabled ? "opacity-[75%]" : ""
                }`}
              onClick={() =>
                handleReload(row.original.date, row.original.file_type, row.id)
              }
              disabled={disabled}
            >
              {isLoading ? (
                <img
                  src={downloadLoader}
                  className="px-2 py-1 text-white brightness-200"
                  alt="loader"
                />
              ) : (
                "RELOAD"
              )}
            </button>
          );
        },
      },
    ],
    [loadingRows],
  );

  return (
    <Table
      pageName={"IndustryScrip"}
      userId={JSON.parse(sessionStorage.getItem("user"))?.userId}
      tableData={tableData}
      columns={columns}
      loading={loading}
    />
  );
};

export default IndustryScripConfig;
